'use client'

import { useEffect } from 'react'
import SiteError from '@/components/reference/SiteError'

export default function ProjectsError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    console.error('Projects error:', error)
  }, [error])

  return (
    <SiteError
      error={error}
      reset={reset}
      title='Failed to load projects'
      message={
        "We couldn't load the portfolio projects. This might be a temporary issue. Please try again."
      }
      links={[{ href: '/', label: 'Go home' }]}
    />
  )
}
